module.exports = __webpack_public_path__ + "static/media/exchange-num.818b6eab.png";